<template>
  <section id="faq" class="faq-section">
    <div class="container">
      <div class="faq-container">
        <h2 class="display-5 text-center text-dark fw-semibold mb-5 fade-in">{{ t('faq.title') }}</h2>

        <div class="accordion" id="faqAccordion">
          <!-- FAQ 1 -->
          <div class="accordion-item">
            <h3 class="accordion-header">
              <button 
                class="accordion-button" 
                :class="{ 'collapsed': openFaq !== 1 }"
                type="button" 
                @click="toggleFaq(1)">
                {{ t('faq.q1.question') }}
              </button>
            </h3>
            <div class="accordion-collapse" :class="{ 'collapse': openFaq !== 1, 'show': openFaq === 1 }">
              <div class="accordion-body text-start">
                {{ t('faq.q1.answer') }}
              </div>
            </div>
          </div>

          <!-- FAQ 2 -->
          <div class="accordion-item">
            <h3 class="accordion-header">
              <button 
                class="accordion-button" 
                :class="{ 'collapsed': openFaq !== 2 }"
                type="button" 
                @click="toggleFaq(2)">
                {{ t('faq.q2.question') }}
              </button>
            </h3>
            <div class="accordion-collapse" :class="{ 'collapse': openFaq !== 2, 'show': openFaq === 2 }">
              <div class="accordion-body text-start">
                {{ t('faq.q2.answer') }}
              </div>
            </div>
          </div>

          <!-- FAQ 3 -->
          <div class="accordion-item">
            <h3 class="accordion-header">
              <button 
                class="accordion-button" 
                :class="{ 'collapsed': openFaq !== 3 }"
                type="button" 
                @click="toggleFaq(3)">
                {{ t('faq.q3.question') }}
              </button>
            </h3>
            <div class="accordion-collapse" :class="{ 'collapse': openFaq !== 3, 'show': openFaq === 3 }">
              <div class="accordion-body text-start">
                {{ t('faq.q3.answer') }}
              </div>
            </div>
          </div>

          <!-- FAQ 4 -->
          <div class="accordion-item">
            <h3 class="accordion-header">
              <button 
                class="accordion-button" 
                :class="{ 'collapsed': openFaq !== 4 }"
                type="button" 
                @click="toggleFaq(4)">
                {{ t('faq.q4.question') }}
              </button>
            </h3>
            <div class="accordion-collapse" :class="{ 'collapse': openFaq !== 4, 'show': openFaq === 4 }">
              <div class="accordion-body text-start">
                {{ t('faq.q4.answer') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/composables/useTranslation'

export default {
  name: 'FaqSection',
  setup() {
    const { t } = useTranslation()
    return { t }
  },
  data() {
    return {
      openFaq: null // null = tous fermés, 1-4 = FAQ ouverte
    }
  },
  methods: {
    toggleFaq(faqNumber) {
      // Si la FAQ est déjà ouverte, la fermer
      if (this.openFaq === faqNumber) {
        this.openFaq = null
      } else {
        // Sinon, fermer les autres et ouvrir celle-ci
        this.openFaq = faqNumber
      }
    }
  }
}
</script>

<!-- TON CSS RESTE IDENTIQUE -->


  <style lang="scss" scoped>

  /* FAQ Section Responsive Styles */
.faq-section {
    padding: 4rem 0;
    background-color: #f8f9fa;
}

.faq-container {
    max-width: 1000px; /* Augmenté de 800px à 1000px */
    margin: 0 auto;
}

.faq-section .accordion-item {
    border: 1px solid rgba(0,0,0,0.1);
    margin-bottom: 0.75rem;
    border-radius: 8px;
    overflow: hidden;
}

/* Style des questions (boutons) */
.faq-section .accordion-button {
    padding: 1.5rem 2rem; /* Padding augmenté */
    font-weight: 600;
    color: #333;
    background-color: #fff;
}

/* Tailles de texte responsive */
@media (min-width: 992px) {
    .faq-section .accordion-button {
        font-size: 1.125rem; /* Plus grand sur desktop */
    }

    .faq-section .accordion-body {
        font-size: 1.05rem; /* Plus grand sur desktop */
        padding: 2rem;
        line-height: 1.7;
    }

    .faq-section h2 {
        font-size: 2.5rem; /* Titre plus grand sur desktop */
        margin-bottom: 3rem;
    }
}

/* Taille moyenne pour tablettes */
@media (min-width: 768px) and (max-width: 991px) {
    .faq-section .accordion-button {
        font-size: 1.05rem;
        padding: 1.25rem 1.75rem;
    }

    .faq-section .accordion-body {
        font-size: 1rem;
        padding: 1.5rem;
    }
}

/* Petits écrans */
@media (max-width: 767px) {
    .faq-section .accordion-button {
        font-size: 0.95rem;
        padding: 1rem 1.25rem;
    }

    .faq-section .accordion-body {
        font-size: 0.9rem;
        padding: 1rem 1.25rem;
    }
}

.faq-section .accordion-button:not(.collapsed) {
    background-color: #f8f9fa;
    color: #000;
    box-shadow: none;
}

.faq-section .accordion-button::after {
    width: 1.5rem; /* Icône plus grande */
    height: 1.5rem;
    background-size: 1.5rem;
}

.faq-section .accordion-body {
    color: #444;
    background-color: #fff;
}

/* Animation hover sur les questions */
.faq-section .accordion-button:hover {
    background-color: #f8f9fa;
}

/* Style spécial pour la question active */
.faq-section .accordion-button:not(.collapsed) {
    font-weight: 700;
}
    
        /* Steps Section */
        .steps-container {
            position: relative;
            padding: 3rem 0;
        }
    
        .step-number {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #000;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1rem;
            font-weight: bold;
        }
    
        .steps-line {
            display: none;
        }
    
        @media (min-width: 992px) {
            .steps-line {
                display: block;
                position: absolute;
                top: 50px;
                left: 50%;
                transform: translateX(-50%);
                width: 70%;
                height: 2px;
                background-image: linear-gradient(to right, #000 50%, transparent 50%);
                background-size: 20px 1px;
                background-repeat: repeat-x;
                z-index: 0;
            }
        }
    
        /* Animations */
        .fade-in {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.5s ease, transform 0.5s ease;
        }
    
        .fade-in.active {
            opacity: 1;
            transform: translateY(0);
        }

        @import '@/assets/styles/main.scss';

    
  </style>